/* eslint-disable jsx-a11y/anchor-is-valid */
import wedifyLogo from "../../assets/logo/wedify-logo-color-hori.png";

const PlainNavbar = () => {
  return (
    <nav className="w-full fixed top-0 left-0 flex items-center px-6 lg:px-20 py-3 shadow-md bg-white z-50">
      <a href="/" className="flex-shrink-0">
        <img src={wedifyLogo} alt="Wedify Logo" className="w-[120px] h-auto" />
      </a>
    </nav>
  );
};

export default PlainNavbar;
